<template>
  <c-page>
    <c-content>
      <!--banner-->
      <c-swipe v-if="banners.length > 0" :images="banners" :auto="0" @click="bannerClick"></c-swipe>
      <template v-for="item in panelItems">
        <c-panel-container v-if="item.title">
          <c-panel-title>
            {{ item.title }}
          </c-panel-title>
        </c-panel-container>
        <c-panel-container>
          <c-panel :img="panelItem.img" :title="panelItem.title" :desc="panelItem.desc" v-for="panelItem in item.items"
                   :key="panelItem.title" @click.native="showDetail(panelItem)">
            <div class="price" v-html="panelItem.price" style="overflow:hidden;"></div>
            <div class="right-point"></div>
          </c-panel>
        </c-panel-container>
      </template>
    </c-content>
  </c-page>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import VasObj from '../../../model/value-added-service'
  import debounce from 'lodash.debounce'
  import IOSAvoidReview from '@/mixins/ios-avoid-review'

  export default {
    data () {
      return {
        vasObj: new VasObj(),
        banners: [],
        bannerArr: [],
        panelItems: []
      }
    },
    mixins: [IOSAvoidReview],
    components: {},
    async created () {
      const isAvoid = await this.$_IOSAvoidReviewMixins_isAvoidReview()
      const data = await this.vasObj.loadData()
      this.bannerArr = data.banner
      if (!isAvoid) {
        for (let item of data.banner) {
          this.banners.push(item.image)
        }
      }
      this.panelItems = data.panelItems
    },
    mounted () {},
    beforeDestroy () {},
    methods: {
      showDetail: debounce(function (item) {
        console.log(item)
        if (item.id === 0) {
          this.$router.push({name: 'rechargePhoneDetail'})
        } else if (item.id === 45) {
          this.$router.push({name: 'rechargeMessageDetail'})
        } else {
          this.$router.push({name: 'vasDetail', params: {id: item.id}})
        }
      }, 220),
      bannerClick (index) {
        let bannerItem = this.bannerArr[index]
        let url = bannerItem.link.url || ''
        if (!url) return
        if (/http|https/.test(url)) {
          this.$store.dispatch('setInnerWebView', url)
          this.$router.push({path: '/innerwebview'})
        } else {
          let tabs = ['senior', 'value-added-service', 'hardware-market', 'all-version', 'realsale20180518']
          if (tabs.includes(url)) {
            this.$bus.$emit('openTab', url) // 打开指定tab
            return
          }
          this.$router.push({path: url})
        }
      }
    },
    computed: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?67903d7f